import En from './en'
import Ru from './ru'
import { enumLang } from './enumLang'

const objectValue = (object, value) => {

  let result = null

  if (typeof value === 'undefined') {
    return result
  }

  function isObject (value) {
    return value && typeof value === 'object'
  }

  if (!isObject(object)) {
    return result
  }

  function getValue (object, value) {

    if (!isObject(object)) {
      return null
    }

    return object[value] || null
  }

  const keys = value.split('.')

  result = object

  for (var i in keys) {
    result = getValue(result, keys[i])

    if (result == null) {
      break
    }
  }

  return result
}

export default {
  install (Vue) {
    // эту переменную необходимо менять в проекте (чтоб тексты ошибок были на нужном языке)
    Vue.prototype.$bimLang = 'ru'

    Vue.prototype.$bimTranslate = function (key, lang) {
      lang = lang || Vue.prototype.$bimLang

      const langObject = lang === enumLang.ru ? Ru : En

      return objectValue(langObject, key) || key
    }

    // @todo remove
    Vue.prototype.$bimChangeLanguage = function (lang) {
    }
  }
}
